import React from 'react';
import ValueListFacet from './ValueListFacet';
import BooleanFilterFacet from './BooleanFilterFacet';
import { checkboxTypes, facetTypes } from '../constants';

const FacetSidebarRow = ({
  category,
  code,
  facetKey,
  facet,
  filter,
  handleFilterUpdate,
  isLoading,
  facetConfig,
  canUpdate,
}) => (
  <>
    {(checkboxTypes.includes(facetConfig.type))
    && (
    <ValueListFacet
      category={category}
      code={code}
      facetConfig={facetConfig}
      facetKey={facetKey}
      facet={facet}
      filter={filter}
      handleFilterUpdate={handleFilterUpdate}
      isLoading={isLoading}
      canUpdate={canUpdate}
    />
    )}
    {(facetConfig.type === facetTypes.BOOLEAN)
    && (
    <BooleanFilterFacet
      category={category}
      code={code}
      facetConfig={facetConfig}
      facetKey={facetKey}
      facet={facet}
      filter={filter}
      isLoading={isLoading}
      handleFilterUpdate={handleFilterUpdate}
      canUpdate={canUpdate}
    />
    )}
  </>
);

export default FacetSidebarRow;
